import React from 'react';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { Field, Form, getIn, withFormik } from 'formik';
import * as Yup from 'yup';
import { Button, Card, Col, Row } from 'react-bootstrap';
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import { indexSelectEmployeesRequest } from '../../requests/employees';
import { FormikRangePicker, FormikSelect, InputSelect } from '../../components';

const debounceEmployeesSelect = AwesomeDebouncePromise(indexSelectEmployeesRequest, 300);

const EVENT_TYPE_OPTIONS = [
  { value: 'create', label: 'Creación' },
  { value: 'update', label: 'Actualización' },
  { value: 'destroy', label: 'Eliminación' }
];

const ShiftAssignmentsHistoryFilters = props => {
  const { errors, touched, setFieldValue, values } = props;
  const dispatch = useDispatch();

  const fetchEmployeeSelect = (inputValue, callback) => {
    const params = {
      active: true,
      filter_name: inputValue,
      sort_column: 'name',
      is_dt: false,
      display_length: 100
    };

    debounceEmployeesSelect({
      dispatch,
      params,
      successCallback: response => {
        callback(response.data.data);
      }
    });
  };

  const handleNewMulti = (data, field) => {
    const newData = data.map(element => element.value);
    setFieldValue(field, newData);
  };

  return (
    <Form>
      <Card>
        <Card className="card-dt">
          <Col className="top-header-green-dt card-header-title-dt">Filtros de Historial de Asignaciones</Col>
          <Card.Body className="div-content card-body-padding">
            <Row>
              <Col sm={12} md={4} xs={12}>
                <Field name="date_range">
                  {({ field }) => (
                    <FormikRangePicker
                      {...field}
                      abbr
                      startDateName="date_from"
                      endDateName="date_to"
                      startDate={values.date_from}
                      endDate={values.date_to}
                      showClearDates
                      error={getIn(errors, field.name)}
                      touched={getIn(touched, field.name)}
                    />
                  )}
                </Field>
              </Col>
              <Col sm={12} md={4} xs={12}>
                <Field name="employees">
                  {({ field }) => (
                    <InputSelect
                      {...field}
                      label="Colaborador(es)"
                      isMulti
                      placeholder="Seleccione colaboradores"
                      value={values.employees}
                      request={fetchEmployeeSelect}
                      onChange={data => {
                        handleNewMulti(data || [], 'filter_employee_ids');
                        setFieldValue(field.name, data || []);
                      }}
                      isClearable
                      error={getIn(errors, field.name)}
                      touched={getIn(touched, field.name)}
                    />
                  )}
                </Field>
              </Col>
              <Col sm={12} md={4} xs={12}>
                <Field name="event_type">
                  {({ field }) => (
                    <FormikSelect
                      {...field}
                      label="Tipo de Evento"
                      placeholder="Seleccione Tipo de Evento"
                      options={EVENT_TYPE_OPTIONS}
                      isClearable
                      onChange={data => {
                        const value = data ? data.value : '';
                        setFieldValue(field.name, value);
                      }}
                      error={getIn(errors, field.name)}
                      touched={getIn(touched, field.name)}
                    />
                  )}
                </Field>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Card>
      <Row className="d-flex justify-content-end">
        <Col md={2}>
          <Button className="btn-block" type="submit">
            Filtrar
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

const validationSchema = Yup.object().shape({
  date_range: Yup.array()
});

const setInitialValues = () => {
  return {
    date_from: moment().startOf('month').format('DD/MM/YYYY'),
    date_to: moment().format('DD/MM/YYYY'),
    date_range: [moment().startOf('month'), moment()],
    employees: [],
    filter_employee_ids: [],
    event_type: ''
  };
};

const handleSubmit = (values, { props }) => {
  const { formRequest } = props;
  const submitValues = { ...values };
  formRequest(submitValues);
};

export default withFormik({
  mapPropsToValues: setInitialValues,
  validationSchema,
  handleSubmit,
  enableReinitialize: false
})(ShiftAssignmentsHistoryFilters);
